import React, { useEffect, useState } from 'react';
import { EditAPVStyle } from './EditAPV.style';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Handleplan from '../Handleplan/Handleplan';
import genereltTranslation from "../../Assets/ListTranslations/Generelt.json"
import SuccesCheckmark from '../../Components/SuccesCheckmark/SuccesCheckmark';
import printImg from "../../Assets/9004704_printer_print_printing_office_work_icon.svg"
import deleteImg from "../../Assets/8664938_trash_can_delete_remove_icon.svg"
import handleplanImg from "../../Assets/2093653_check_checklist_list_mark_ok_icon.svg"
import saveImg from "../../Assets/8666542_save_icon.svg"
import jumpImg from "../../Assets/9041819_jump_right_icon.svg"
import QRCodeComponent from '../../Components/QrCode/QrCode';
import realtimeImg from "../../Assets/7787508_duplicate_copy_documents_folder_file_icon.svg"
import clientpageImg from "../../Assets/9041305_person_lines_fill_icon.svg"
import mailImg from "../../Assets/622401_mail_packet_email_envelope_letter_icon.svg"

function EditAPV() {
  const { id } = useParams()
  const navigate = useNavigate();
  const [num, setNum] = useState(0);
  const [newQuestion, setNewQuestion] = useState(null);
  const [textInput, setTextInput] = useState('');
  const [handleplanShow, setHandleplanShow] = useState([null,null]);
  const [translateError, setTranslateError] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [language, setLanguage] = useState("en");
  const [prevLanguage, setPrevLanguage] = useState("en");
  const [hoverIndex, setHoverIndex] = useState(null);
  const [farmerId, setFarmerId] = useState(null);
  const [farmerData, setFarmerData] = useState(null);
  const [isPrint, setIsPrint] = useState(false);
  const [data, setData] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const [success, setSuccess] = useState(false);
  const [realtime, setRealtime] = useState(false);
  const [documentData, setDocumentData] = useState(false);
  const [documentLink, setDocumentLink] = useState("");
  const [deletedQuestions, setDeletedQuestions] = useState([]); // [{sectionIndex, questionIndex, question, id}]

console.log(JSON.parse(sessionStorage.getItem('user')).id);

  const handleUpdate = () => {
    updateAPV(id,data)
    setHandleplanShow([null,null])
  }

  useEffect(() => {
    let interval;
    if (realtime) {
      interval = setInterval(() => {
        updateAPV(id, data, true);
      }, 5000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [realtime]);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const addNewQuestion = (index) => {
    data[index].questions.push({ 
      question: textInput, 
      status: '', 
      deadline: "", 
      explanation: "", 
      problem: "", 
      responsible: ""
    });
    setNum(num + 1);
    setNewQuestion(null);
  };

  const deleteQuestion = (sectionIndex, questionIndex) => {
    const newData = [...data];
    const removed = newData[sectionIndex].questions.splice(questionIndex, 1)[0];
    setData(newData);

    const entry = { sectionIndex, questionIndex, question: removed, id: Date.now() };
    setDeletedQuestions(prev => [...prev, entry]);

    setTimeout(() => {
      setDeletedQuestions(prev => prev.filter(e => e.id !== entry.id));
    }, 5000);
  };

  const undoDelete = (entry) => {
    const newData = [...data];
    newData[entry.sectionIndex].questions.splice(entry.questionIndex, 0, entry.question);
    setData(newData);
    setDeletedQuestions(prev => prev.filter(e => e.id !== entry.id));
  };

  const addStatus = (sectionIndex, questionIndex, status) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].status = status;
    setData(newData);
    if (status === "Udfordring") {
      setHandleplanShow([sectionIndex, questionIndex])
    }
  };

  const addDeadline = (sectionIndex, questionIndex, deadline) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].deadline = deadline;
    setData(newData);
  };

  const addExplantion = (sectionIndex, questionIndex, explanation) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].explanation = explanation;
    setData(newData);
  };

  const addResponsible = (sectionIndex, questionIndex, responsible) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].responsible = responsible;
    setData(newData);
  };

  const addComment = (sectionIndex, questionIndex, comment) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].comment = comment;
    setData(newData);
    console.log(data);
  };

  const sendLink = async () => {
    axios.post('https://api.agrop.eu/send-rapport', {
      email: farmerData.email,
      link: documentLink,
      userId: JSON.parse(sessionStorage.getItem('user')).id || 0,
    })
    .then(function (response) {
      console.log(response);
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://api.agrop.eu/getApv/${id}`);
        const response2 = await axios.get(`https://api.agrop.eu/getFarmer/${response.data.clientId}`);
        setData(response.data.content.APV || response.data.content);
        console.log(data);
        setDocumentData(response.data)
        setFarmerId(response.data.clientId);
        console.log(response.data);
        setFarmerData(response2.data)
        console.log(response2.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
    return () => {};
  }, []);
  
  useEffect(() => {
    const h2Elements = Array.from(document.querySelectorAll('h2'));
    const optionElements = h2Elements.map((item, index) => (
      <p key={index} onClick={() => {document.getElementById(item.innerText.replace(' ', '-')).scrollIntoView({ behavior: 'smooth' }); setModalOpen(false)}}>{item.innerText}</p>
    ));
    setOptions(optionElements);
    setDocumentLink(`https://app.agrop.eu/readapv/${documentData.id}/${documentData.documentKey}`);
  }, [data]);

  const translateText = async (text) => {
    try {
      const response = await axios.post('https://lang.kvægapv.eu/translate', { text, targetLanguage: language, startLanguage: prevLanguage });
      return response.data.translatedText;
    } catch (error) {
      console.error('Translation error:', error);
      throw error;
    }
  };

  const translateJSON = async (json) => {
    try {
      for (const section of json) {
        if (section.questions && Array.isArray(section.questions)) {
          for (const questionObj of section.questions) {
            if (questionObj.question) {
              const textToTranslate = questionObj.question[prevLanguage];
              const translatedText = await translateText(textToTranslate);
              questionObj.question[language] = translatedText;
            }
          }
        }
      }
      return json;
    } catch (error) {
      console.error('Translation error:', error);
      throw error;
    }
  };

  const translateAndAddQuestion = async (index) => {
    try {
      const translatedQuestion = await translateText(textInput);
      data[index].questions.push({ 
        question: translatedQuestion, 
        status: '', 
        deadline: "", 
        explanation: "", 
        problem: "", 
        responsible: "" 
      });
      setNum(num + 1);
      setNewQuestion(null);
    } catch (error) {
      console.error('Translation error:', error);
      setTranslateError(true)
    }
  };

  const translateWholePage = async (json) => {
    try {
      if (!json) {
        console.error('JSON data is null or undefined');
        return;
      }
      if (typeof json !== 'object' || !Symbol.iterator in Object(json)) {
        console.error('JSON data is not iterable');
        return;
      }
      const translatedJSON = await translateJSON(json);
      const textElements = Array.from(document.querySelectorAll('p, h1, h2, h3, h4, h5, h6, button'));
      for (let i = 0; i < textElements.length; i++) {
        const text = textElements[i].innerText;
        const matchedText = findMatchedText(translatedJSON, text);
        if (matchedText) {
          const translatedText = await translateText(matchedText);
          textElements[i].innerText = translatedText;
        }
      }
    } catch (error) {
      console.error('Translation error:', error);
    }
  };

  const findMatchedText = (json, text) => {
    for (const section of json) {
      if (section.questions && Array.isArray(section.questions)) {
        for (const questionObj of section.questions) {
          if (questionObj.question && questionObj.question.da === text) {
            return questionObj.question[language];
          }
        }
      }
    }
    return null;
  };

  const deleteAPV = async (apvId, apvName) => {
    console.log(apvId);
    try {
      const isSure = window.confirm(`Er du sikker på at du vil slette denne rapport?`);
      if (isSure) {
        const response = await axios.post(`https://api.agrop.eu/delAPV`, {
          id: apvId,
          userId: JSON.parse(sessionStorage.getItem('user')).id || 0,
        });
      }
    } catch (error) {
      console.error('Send login error:', error);
      throw error;
    }
  };

  const updateAPV = async (id, content) => {
    console.log(id);
    try {
      const response = await axios.put(`https://api.agrop.eu/updateapv/${id}`, {
        content: JSON.stringify(content),
        userId: JSON.parse(sessionStorage.getItem('user')).id || 0,
      });
      if (!realtime) {
        setTimeout(() => {
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, 1500);
        }, 200);
      }
    } catch (error) {
      console.error('Update error:', error);
      throw error;
    }
  };

  console.log(genereltTranslation.APV);

  return (
    <EditAPVStyle>
      {success && <SuccesCheckmark />}

      {/* Undo delete toast */}
      {deletedQuestions.length > 0 && (
        <div style={{
          position: "fixed", bottom: "2rem", left: "50%", transform: "translateX(-50%)",
          display: "flex", flexDirection: "column", gap: "0.5rem", zIndex: 9999
        }}>
          {deletedQuestions.map(entry => (
            <div key={entry.id} style={{
              background: "#333", color: "#fff", padding: "0.75rem 1.25rem",
              borderRadius: "8px", display: "flex", alignItems: "center", gap: "1rem",
              boxShadow: "0 4px 12px rgba(0,0,0,0.3)", fontSize: "0.9rem",
              whiteSpace: "nowrap"
            }}>
              <span>Spørgsmål slettet</span>
              <button onClick={() => undoDelete(entry)} style={{
                background: "#fff", color: "#333", border: "none",
                borderRadius: "4px", padding: "0.25rem 0.75rem",
                cursor: "pointer", fontWeight: "bold"
              }}>Fortryd</button>
            </div>
          ))}
        </div>
      )}

      {!modalOpen ? <QRCodeComponent data={"/readapv/" + id} /> : null}

      {data ? <>
        <div className='btnDiv2'>
          <span id='theTop'></span>
          <button id='toTop' onClick={() => document.getElementById('theTop').scrollIntoView({ behavior: 'smooth' })}>⬆️</button>
          <button id='modalBtn' style={{display: !isDesktop ? "none" : "block"}} onClick={() => setModalOpen(modalOpen ? false : true)}>{'Hop til'}</button>
        </div>

        <div className='btnDiv' style={{display: isDesktop ? "grid" : "grid"}}>
          <button onClick={() => updateAPV(id,data)}> <img src={saveImg} alt="gem" /> </button>
          <button onClick={() => deleteAPV(id)}> <img src={deleteImg} alt="Slet" /> </button>
          <button style={{display: !isDesktop ? "none" : "block"}} onClick={() => {
            document.getElementsByClassName('btnDiv2')[0].style.display = "none"
            document.getElementsByClassName('btnDiv')[0].style.display = "none"
            document.getElementsByClassName('categoryDiv')[0].style.gridTemplateColumns = "40% 12% 12% 12% 24%";
            for (let index = 0; index < document.getElementsByClassName('headingArt').length; index++) {
              document.getElementsByClassName('headingArt')[index].style.gridTemplateColumns = "0% 40% 12% 12% 12% 24%";
            }
            document.getElementsByTagName('header')[0].style.display = "none"
            document.getElementById('docLinkDiv').style.display = "none"
            document.getElementsByClassName('desktopForm')[0].style.width = "100%"
            document.getElementsByClassName('desktopForm')[0].style.marginLeft = "0"
            document.getElementsByClassName('desktopForm')[0].style.marginTop = "0"
            setIsPrint(true)
            setTimeout(() => { window.print() }, 200);
            setTimeout(() => {
              document.getElementsByClassName('btnDiv2')[0].style.display = "block"
              document.getElementsByClassName('btnDiv')[0].style.display = "grid"
              document.getElementsByClassName('categoryDiv')[0].style.gridTemplateColumns = "50% 7% 7% 7% 29%";
              for (let index = 0; index < document.getElementsByClassName('headingArt').length; index++) {
                document.getElementsByClassName('headingArt')[index].style.gridTemplateColumns = "10% 40% 7% 7% 7% 29%";
              }
              document.getElementsByTagName('header')[0].style.display = "block"
              document.getElementById('docLinkDiv').style.display = "block"
              document.getElementsByClassName('desktopForm')[0].style.width = "80vw"
              document.getElementsByClassName('desktopForm')[0].style.marginLeft = "12.5rem"
              setIsPrint(false)
            }, 200);
          }}> <img src={printImg} alt="Print" /> </button>

          <button onClick={() => {
            handleUpdate()
            setTimeout(() => { navigate(`/handleplaner/${id}`) }, 500);
          }}> <img src={handleplanImg} alt="handleplaner" /> </button>
          <button style={{display: isDesktop ? "none" : "block"}} onClick={() => setModalOpen(modalOpen ? false : true)}><img src={jumpImg} alt="Jump to" /></button>
          <button style={{ backgroundColor: realtime ? "green" : "white"}} onClick={() => realtime ? setRealtime(false) : setRealtime(true)}> <img src={realtimeImg} alt="realtime" /> </button>
          <button onClick={() => navigate(`/clientlookup/${farmerId}`)}> <img src={clientpageImg} alt="clientpage" /> </button>
          <button onClick={() => {
            sendLink()
            alert("link sendt")
          }}><img src={mailImg} alt="Send link" /></button>
        </div>

        {modalOpen && (
          <div className="modal">
            <div className="modal-content">
              {options}
            </div>
          </div>
        )}

        {!isDesktop ? (
          <section key={num} className='mobileForm'>
            {data.length > 0 ? data.map((item, index) => (
              <React.Fragment key={index}>
                <h2 id={item.heading.replace(' ', '-')}>{item.heading}</h2>
                {item.questions.map((question, qIndex) => (
                  <div key={qIndex}>
                    <p onClick={() => deleteQuestion(index, qIndex)}>X</p>
                    <p>{question.question}</p>
                    <button
                      style={{ backgroundColor: question.status === 'Udfordring' ? 'red' : 'initial' }}
                      onClick={() => addStatus(index, qIndex, 'Udfordring')}
                    >
                      Udfordring
                    </button>
                    <button
                      style={{ backgroundColor: question.status === 'I orden' ? 'green' : 'initial' }}
                      onClick={() => addStatus(index, qIndex, 'I orden')}
                    >
                      I orden
                    </button>
                    <button
                      style={{ backgroundColor: question.status === 'Irrelevant' ? 'gray' : 'initial' }}
                      onClick={() => addStatus(index, qIndex, 'Irrelevant')}
                    >
                      Irrelevant
                    </button>
                  </div>
                ))}
                {newQuestion === null ? (
                  <button onClick={() => setNewQuestion(index)}>Nyt spørgsmål</button>
                ) : null}
                {newQuestion === index ? (
                  <div>
                    <input type="text" onChange={(e) => setTextInput(e.target.value)} />
                    <button onClick={() => translateAndAddQuestion(index)}>Tilføj</button>
                    <button onClick={() => setNewQuestion(null)}>Annuller</button>
                  </div>
                ) : null}
              </React.Fragment>
            )) : <h2>Denne rapport er tom</h2>}
          </section>
        ) : (
          <section key={num} className='desktopForm'>
            {data.map((item, index) => (
              <React.Fragment key={index}>
                <div onMouseOver={() => setHoverIndex(index)} onMouseLeave={() => setHoverIndex(null)}>
                  <div className='categoryDiv' style={{display: data[index].questions.length > 0 ? "grid" : "none"}}>
                    <h2 id={item.heading.replace(' ', '-')} style={{backgroundColor: "#D9D9D9", borderLeft: "solid black 1px"}}>{item.heading}</h2>
                    <p style={{backgroundColor: "#CF4040"}} onClick={() => {
                      item.questions.map((question, qIndex) => { addStatus(index, qIndex, 'Udfordring') })
                    }}>Udfordring</p>
                    <p style={{backgroundColor: "#28C253"}} onClick={() => {
                      item.questions.map((question, qIndex) => { addStatus(index, qIndex, 'I orden') })
                    }}>I orden</p>
                    <p style={{backgroundColor: "#B8B8B8", borderRight: "solid black 1px"}} onClick={() => {
                      item.questions.map((question, qIndex) => { addStatus(index, qIndex, 'Irrelevant') })
                    }}>Irrelevant</p>
                    <p style={{backgroundColor: "#0099ff"}}>Kommentar</p>
                  </div>

                  {item.questions.map((question, qIndex) => (
                    <React.Fragment key={`${index}-${qIndex}`}>
                      <article className='headingArt'>
                        <p style={{paddingTop: "1vh"}} onClick={() => deleteQuestion(index, qIndex)}>{isPrint ? " " : "X"}</p>
                        <div>
                          <span><p>{question.question}</p><p>{isPrint ? " " : " "}</p></span>
                        </div>
                        <div style={{borderRight: "solid black 1px", borderLeft: "solid black 1px"}} onClick={() => addStatus(index, qIndex, 'Udfordring')}>{question.status === "Udfordring" ? "x" : ""}</div>
                        <div style={{borderRight: "solid black 1px"}} onClick={() => addStatus(index, qIndex, 'I orden')}>{question.status === "I orden" ? "x" : ""}</div>
                        <div style={{borderRight: "solid black 1px"}} onClick={() => addStatus(index, qIndex, 'Irrelevant')}>{question.status === "Irrelevant" ? "x" : ""}</div>
<div><textarea value={question.comment || ""} onChange={(e) => addComment(index, qIndex, e.target.value)} name="" id=""></textarea></div>
                      </article>

                      <article className='handleplanArt' style={{display: index === handleplanShow[0] && qIndex === handleplanShow[1] ? "grid" : "none"}}>
                        <div>
                          <h3>Beskriv problemet</h3>
                          <textarea name="" id="" cols="30" rows="5" defaultValue={question.explanation} onChange={(e) => addExplantion(index, qIndex, e.target.value)}></textarea>
                        </div>
                        <div className='deadlineDiv'>
                          <h3>Deadline</h3>
                          <div className='deadlineInputDiv'>
                            <label htmlFor="">Løses straks</label>
                            <input type="radio" name="" id="" defaultValue={question.deadline} onChange={(e) => addDeadline(index, qIndex, new Date().toLocaleDateString('en-GB'))}/>
                            <label htmlFor="">Løses inden </label>
                            <input type="date" name="" id="" defaultValue={question.deadline} onChange={(e) => addDeadline(index, qIndex, new Date(e.target.value).toLocaleDateString('en-GB'))} />
                          </div>
                        </div>
                        <div>
                          <h3>Ansvarlig</h3>
                          <input placeholder='Ansvarlig' type="text" defaultValue={question.responsible} onChange={(e) => addResponsible(index, qIndex, e.target.value)}/>
                        </div>
                        <div>
                          <button onClick={() => {
                            updateAPV(id, data)
                            setHandleplanShow([null, null])
                          }}>Gem</button>
                          <button onClick={() => setHandleplanShow([null, null])}>Senere</button>
                        </div>
                      </article>
                    </React.Fragment>
                  ))}

                  {hoverIndex === index && isPrint === false ? (
                    <button className='newQuestion' onClick={() => setNewQuestion(index)}>Nyt spørgsmål</button>
                  ) : null}

                  {newQuestion === index ? (
                    <article key={`new-${index}`} className='headingArt' id='newQuestionArt'>
                      <p></p>
                      <div>
                        <input
                          type="text"
                          placeholder='Skriv nyt spørgsmål her...'
                          value={textInput}
                          onChange={(e) => setTextInput(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                              if (language === "en") {
                                addNewQuestion(index);
                              } else {
                                setTimeout(() => {
                                  if (translateError) {
                                    addNewQuestion(index);
                                    setTranslateError(false);
                                  } else {
                                    translateAndAddQuestion(index);
                                  }
                                }, 500);
                              }
                              setNewQuestion(null);
                              setTextInput("");
                            }
                          }}
                        />
                      </div>
                      <div>
                        <button onClick={() => {
                          addNewQuestion(index);
                          setNewQuestion(null);
                          setTextInput("")
                        }}>✓</button>
                        <button onClick={() => {
                          setNewQuestion(null);
                          setTextInput("")
                        }}>x</button>
                      </div>
                      <div onClick={() => addStatus(index, item.questions.length, 'Udfordring')}></div>
                      <div onClick={() => addStatus(index, item.questions.length, 'I orden')}></div>
                      <div onClick={() => addStatus(index, item.questions.length, 'Irrelevant')}></div>
                    </article>
                  ) : null}
                </div>
              </React.Fragment>
            ))}

            <div id='docLinkDiv'>
              <h1 style={{marginTop: "10%"}}>Link til rapport</h1>
              <input type="text" value={documentLink} style={{width: "50%"}} />
            </div>
          </section>
        )}
      </> : <h2 style={{position: "absolute", left: "38vw", top: "40vh"}}>Henter rapporten...</h2>}
    </EditAPVStyle>
  );
}

export default EditAPV;